import { type Schedule } from '../../types';
import { useScheduleActivation } from '../../schedule/activation/hooks/useScheduleActivation';
import ScheduleActivationModals from '../../schedule/activation/components/ScheduleActivationModals';

interface Props {
  countryCode: string;
  schedule: Schedule;
  onActivated: () => void;
  onCancelled: () => void;
}

export default function PostConnectionActivation({
  countryCode,
  schedule,
  onActivated,
  onCancelled,
}: Props) {
  const activation = useScheduleActivation({
    initialSchedule: schedule,
    onActivated,
    onCancelled,
  });

  return <ScheduleActivationModals countryCode={countryCode} activation={activation} />;
}
